import "./styles.scss";

import { useIntl } from "react-intl";
import { Asset } from "../../models/asset";
import Checkups from "./components/checkups";
import OilChange from "./components/oilChange";
import usePeriodicReviews from "../../hooks/usePeriodcReviews";
import { useMediaQuery } from "@mui/material";
import useAssets from "../../hooks/useAssets";

interface IIPeriodicReviewsProps {
  dialog: boolean;
  closeSidebar: () => void;
  asset: Asset | null;
  scheduleIds: string[];
  userRole: 'TOWER' | 'CONSULTANT' | 'MANAGER' | 'PARTNERSHIP';
}

const PeriodicReviews = ({ dialog, closeSidebar, asset, scheduleIds, userRole }: IIPeriodicReviewsProps) => {
  const intl = useIntl();
  const { activeTab, setActiveTab, blockchainData, loading } = usePeriodicReviews({ chassis: asset?.chassis ?? "", scheduleIds, userRole, dialog });
  const isResponsiveView = useMediaQuery("(max-width: 768px)");
  const { getAssetById } = useAssets();
  const summaryAsset = asset?.id ? getAssetById(asset.id) : undefined;
  const displayName = summaryAsset?.name && summaryAsset.name !== summaryAsset.chassis ? summaryAsset.name : undefined;
  const displayPlate = summaryAsset?.licensePlate && summaryAsset.licensePlate !== summaryAsset.chassis ? summaryAsset.licensePlate : undefined;

  return (
    <>
      <div className="bg-right-sidebar" onClick={() => closeSidebar()} />
      <div className={`right-sidebar ${isResponsiveView ? "!w-[80%]" : "!w-[450px]"}`}>
        <h3 className="flex gap-6 margin-bottom-20">
          <span className="rioglyph rioglyph-book"></span>
          {intl.formatMessage({ id: "intl-msg:common.periodicReviews" })}
        </h3>
        <div
          className="close-sidebar cursor-pointer"
          onClick={() => closeSidebar()}
        >
          <span className="rioglyph rioglyph-remove"></span>
        </div>

        {asset && (
          <div className="vehicle-header">
            <div className="vehicle-header__name">
              <span className="rioglyph rioglyph-truck text-size-16 margin-right-5"></span>
              <span className="text-size-14 font-semibold">{displayName ?? "-"}</span>
            </div>
            <div className="vehicle-header__details">
              <span className="vehicle-header__badge">
                <span className="rioglyph rioglyph-barcode text-size-12 margin-right-4"></span>
                {asset.chassis || "-"}
              </span>
              <span className="vehicle-header__badge">
                <span className="rioglyph rioglyph-card text-size-12 margin-right-4"></span>
                {displayPlate ?? "-"}
              </span>
            </div>
          </div>
        )}

        <div className="w-full">
          <div className="p-0">
            {/* <div className="flex space-x-8 mb-6">
              <button
                onClick={() => setActiveTab("revisoes")}
                className={`text-size-16 font-semibold ${
                  activeTab === "revisoes"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
              >
                Revisões
              </button>
              <button
                // onClick={() => setActiveTab("trocaDeOleo")}
                className={`text-size-16 font-semibold ${
                  activeTab === "trocaDeOleo"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
                style={{ cursor: "not-allowed" }}
              >
                Troca de óleo
              </button>
            </div> */}

            {activeTab === "revisoes" && <Checkups asset={asset} blockchainData={blockchainData} loading={loading} />}

            {activeTab === "trocaDeOleo" && <OilChange asset={asset} blockchainData={blockchainData} loading={loading} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default PeriodicReviews;
